import { BaseApiUrl } from "../../../configVariables";
import { Config } from "../../../model/Config";
import apiClient from "../../../utils/apiClient";

export const getConfig = async () => {
  const url = `${BaseApiUrl}/config`;
  return await apiClient.get<Config>(url);
}